
(() => {
  if (window.BrentosPrintGridLoaded) return;
  window.BrentosPrintGridLoaded = true;

  async function loadMore(event) {
    const button = event.target.closest('[data-print-grid-more]');
    if (!button) return;

    event.preventDefault();

    const section = button.closest('[data-brentos-print-grid]');
    const grid = section?.querySelector('[data-print-grid-items]');
    if (!grid || button.dataset.loading === 'true') return;

    button.dataset.loading = 'true';

    const label = button.querySelector('.button__text');
    if (label) label.textContent = 'Loading prints...';

    try {
      const response = await fetch(button.href, {
        credentials: 'same-origin'
      });

      if (!response.ok) throw new Error('Unable to load prints');

      const html = await response.text();
      const documentPage = new DOMParser().parseFromString(html, 'text/html');

      const nextSection = documentPage.getElementById(section.id);
      const nextGrid = nextSection?.querySelector('[data-print-grid-items]');

      if (!nextGrid) throw new Error('Product grid not found');

      const products = Array.from(nextGrid.children);
      const fragment = document.createDocumentFragment();

      products.forEach(product => fragment.appendChild(product));
      grid.appendChild(fragment);

      const nextButton = nextSection.querySelector('[data-print-grid-more]');
      const nextStatus = nextSection.querySelector('[data-print-grid-status]');
      const status = section.querySelector('[data-print-grid-status]');

      if (status && nextStatus) status.textContent = nextStatus.textContent;

      if (nextButton) {
        button.href = nextButton.href;
        if (label) label.textContent = 'Load more prints';
      } else {
        button.remove();
      }

      // Update bundle button labels on newly loaded cards.
      const bundleSection = document.querySelector(
        '[data-brentos-bundle][data-collection-handle="fine-art-prints"]'
      );

      if (bundleSection) {
        const customLabel = bundleSection.dataset.buttonLabel || 'Choose options';

        products.forEach(card => {
          const addButton = card.querySelector('[data-js-product-add-to-cart]');
          const buttonLabel = addButton?.querySelector('.button__text');

          if (!buttonLabel || addButton.hasAttribute('disabled')) return;

          buttonLabel.textContent = addButton.closest('quick-view-product')
            ? customLabel
            : 'Add to bundle';
        });
      }

    } catch (error) {
      console.error('Art print Load More:', error);
      if (label) label.textContent = 'Try loading again';
    } finally {
      button.dataset.loading = 'false';
    }
  }

  document.addEventListener('click', loadMore);
})();
